<template>
  <login-panel
    class="software-license-confirmation"
    back-route-name="software-license-text"
  >
    <h3
      class="software-license-confirmation__title"
      slot="login-panel-header"
    >
      {{ $t('login.software-license') }}
    </h3>
    <div class="software-license-confirmation__container">
      <div class="software-license-confirmation__content">
        <p class="software-license-confirmation__instruction">
          {{ $t('login.software-license-confirmation-instruction') }}
        </p>
        <label
          class="software-license-confirmation__label"
          for="name"
        >
          {{ $t('general.name') }}
        </label>
        <b-form-input
          v-model="name"
          id="name"
          type="text"
          maxlength="150"
          :state="$bsStateValidator($v.name.$error)"
          @input="$v.name.$touch()"
        ></b-form-input>
        <label
          class="software-license-confirmation__label"
          for="cpf"
        >
          {{ $t('general.cpf') }}
        </label>
        <b-form-input
          v-model="cpfProxy"
          v-mask="cpfMask"
          id="cpf"
          type="text"
          :state="$bsStateValidator($v.cpf.$error)"
          :maxlength="cpfMask.length"
          @input="$v.cpf.$touch()"
        ></b-form-input>
        <b-form-checkbox
          class="software-license-confirmation__declare-read"
          v-model="declareRead"
          id="declareRead"
        >
          {{ $t('login.read-software-license') }}
        </b-form-checkbox>
      </div>
    </div>
    <div
      class="software-license-confirmation__footer"
      slot="login-panel-footer"
    >
      <s-loading-button
        class="software-license-confirmation__next-btn"
        variant="primary"
        id="next"
        :disabled="!canTryConfirm"
        :loading="isLoadingConfirm"
        @click="confirm()"
      >
        {{ $t('general.confirm') }}
      </s-loading-button>
    </div>
  </login-panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import LoginPanel from '@/components/LoginPanel';
import { cpfMask } from '@/services/maskService';
import isValidCpf from '@/services/validations/cpfValidationService';
import SoftwareLicenseService from '@/domain/services/generalPanel/softwareLicense';

const NAME_MIN_CHARS = 2;

export default {
  props: {
    cpf: {
      type: String,
      required: true,
    },
  },
  components: {
    LoginPanel,
  },
  data() {
    return {
      name: `${this.$store.getters.user.firstName} ${this.$store.getters.user.surname}`,
      declareRead: true,
      isLoadingConfirm: false,
    };
  },
  validations: {
    name: {
      required,
    },
    cpf: {
      required,
    },
  },
  computed: {
    cpfProxy: {
      get() {
        return this.cpf;
      },
      set(value) {
        this.$emit('update:cpf', value);
      },
    },
    cpfMask: () => cpfMask,
    canTryConfirm() {
      return !this.$v.$invalid && this.declareRead && !this.isLoadingConfirm;
    },
  },
  methods: {
    confirm() {
      let canConfirm = this.canTryConfirm;
      if (!this.name || this.name.length < NAME_MIN_CHARS) {
        canConfirm = false;
        this.$pushAlert({
          code: 'MA010',
          messageParams: {
            NomeDoCampo: this.$t('general.name'),
            NroCaracteres: NAME_MIN_CHARS,
          },
        });
      }
      if (!this.cpf || !isValidCpf(this.cpf)) {
        canConfirm = false;
        this.$pushAlert({ code: 'ME011' });
      }

      if (canConfirm) {
        this.isLoadingConfirm = true;
        SoftwareLicenseService.acceptLicenseAndProceed({
          name: this.name,
          cpf: this.cpf,
        }).finally(() => {
          this.isLoadingConfirm = false;
        });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .software-license-confirmation
    &__title
      font-size: 1.1rem
      font-weight: 600
      text-transform: uppercase
    &__next-btn
      float: right
      font-weight: 600
      padding-left: 30px
      padding-right: 30px
    &__label
      font-weight: 600
      margin-top: 20px
    &__instruction
      text-align: center
    &__declare-read
      margin-top: 20px
    +media-min-sm()
    +media-min-md()
      &__container
        display: flex
        justify-content: center
      &__content
        width: 50%
    +media-min-lg()
</style>
